goog.provide("shadow.js.shim.module$dayjs$locale$fa");
goog.provide("module$shadow_js_shim_module$dayjs$locale$fa");
shadow.js.shim.module$dayjs$locale$fa = shadow.js.nativeProvides["dayjs/locale/fa"] = require("dayjs/locale/fa");
module$shadow_js_shim_module$dayjs$locale$fa.default = shadow.js.shim.module$dayjs$locale$fa;
